import { ObservableModelNode } from "../observable";
import type { SpecsAutoFormFieldMetadataMap } from "../autoFormMetadata";
import {
  cloneValue,
  expectObject,
  readObjectArray,
  readOptionalNumber,
  readString,
  splitKnown,
} from "../utils";
import { DecorationCreditsStepModel } from "./DecorationCreditsStepModel";

export class DecorationCreditsModel extends ObservableModelNode {
  static autoFormFields: SpecsAutoFormFieldMetadataMap = {
    initialCredits: {
      label: "Initial credits",
      fieldType: "number",
      allowNull: true,
    },
    priceExplanationKey: {
      label: "Price explanation key",
      fieldType: "text",
    },
    extra: { label: "Extra JSON", fieldType: "json", minRows: 4 },
  };

  initialCredits!: number | null;
  priceExplanationKey!: string;
  extraCreditsBasedOnSideLength!: DecorationCreditsStepModel[];
  extra!: Record<string, unknown>;

  constructor() {
    super();
    this.defineObservableValue("initialCredits", 0);
    this.defineObservableValue("priceExplanationKey", "draft");
    this.defineObservableValue("extraCreditsBasedOnSideLength", []);
    this.defineObservableValue("extra", {});
  }

  restore(snapshot: unknown) {
    const source = expectObject(snapshot, "decoration credits");
    this.initialCredits = readOptionalNumber(source, "initialCredits");
    this.priceExplanationKey = readString(source, "priceExplanationKey");
    this.extraCreditsBasedOnSideLength = readObjectArray(
      source,
      "extraCreditsBasedOnSideLength"
    ).map((entry) => new DecorationCreditsStepModel().restore(entry));
    this.extra = splitKnown(source, [
      "initialCredits",
      "priceExplanationKey",
      "extraCreditsBasedOnSideLength",
    ]);
    return this;
  }

  save() {
    return {
      ...cloneValue(this.extra),
      ...(this.initialCredits !== null
        ? { initialCredits: this.initialCredits }
        : {}),
      ...(this.priceExplanationKey
        ? { priceExplanationKey: this.priceExplanationKey }
        : {}),
      extraCreditsBasedOnSideLength: this.extraCreditsBasedOnSideLength.map(
        (entry) => entry.save()
      ),
    };
  }
}
